<template>
  <section class="sign-in-page bg-white">
    <router-view></router-view>
  </section>
</template>

<script>
// // import { sofbox } from '@/config/pluginInit';

export default {
  name: 'AuthLayout',
  // mounted() {
  //   sofbox.mainIndex();
  // },
};
</script>
